const GetCommodityLandingSBACCIReportCountReducer = (state = { type: 'LOADING_SBA_CCI_REPORT_COUNT_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SBA_CCI_REPORT_COUNT_ACTION':
            return action
        case 'RESET_SBA_CCI_REPORT_COUNT_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetSBACCIDateReducer = (state = { type: 'LOADING_SBA_CCI_DATE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SBA_CCI_DATE_ACTION':
            return { ...state, type: 'LOADING_SBA_CCI_DATE_ACTION', loading: true };
        case 'SUCCESS_SBA_CCI_DATE_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SBA_CCI_DATE_ACTION':
            return { ...state, type: 'ERROR_SBA_CCI_DATE_ACTION', loading: false, error: action.error };
        case 'RESET_SBA_CCI_DATE_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetSBACCIDetailReducer = (state = { type: 'LOADING_SBA_CCI_DETAIL_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SBA_CCI_DETAIL_ACTION':
            return { ...state, type: 'LOADING_SBA_CCI_DETAIL_ACTION', loading: true };
        case 'SUCCESS_SBA_CCI_DETAIL_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SBA_CCI_DETAIL_ACTION':
            return { ...state, type: 'ERROR_SBA_CCI_DETAIL_ACTION', loading: false, error: action.error };
        case 'RESET_SBA_CCI_DETAIL_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetCMAPageFilterReducer = (state = { type: 'LOADING_CMA_PAGE_FILTER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CMA_PAGE_FILTER_ACTION':
            return { ...state, type: 'LOADING_CMA_PAGE_FILTER_ACTION', loading: true };
        case 'SUCCESS_CMA_PAGE_FILTER_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CMA_PAGE_FILTER_ACTION':
            return { ...state, type: 'ERROR_CMA_PAGE_FILTER_ACTION', loading: false, error: action.error };
        case 'RESET_CMA_PAGE_FILTER_ACTION':
            return {
                ...state,
                type: action.payload,
            };  
        default:
            return state
    }
}

const GetCMALineChartReducer = (state = { type: 'LOADING_CMA_LINE_CHART_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CMA_LINE_CHART_ACTION':
            return { ...state, type: 'LOADING_CMA_LINE_CHART_ACTION', loading: true };
        case 'SUCCESS_CMA_LINE_CHART_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CMA_LINE_CHART_ACTION':
            return { ...state, type: 'ERROR_CMA_LINE_CHART_ACTION', loading: false, error: action.error };
        case 'RESET_CMA_LINE_CHART_ACTION':
            return {
                ...state,
                type: action.payload,
            };  
        default:
            return state
    }
}

const GetCMATableReducer = (state = { type: 'LOADING_CMA_TABLE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CMA_TABLE_ACTION':
            return { ...state, type: 'LOADING_CMA_TABLE_ACTION', loading: true };
        case 'SUCCESS_CMA_TABLE_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CMA_TABLE_ACTION':
            return { ...state, type: 'ERROR_CMA_TABLE_ACTION', loading: false, error: action.error };
        case 'RESET_CMA_TABLE_ACTION':
            return {
                ...state,
                type: action.payload,
            };  
        default:
            return state
    }
}

const GetCMADateReducer = (state = { type: 'LOADING_CMA_DATE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_CMA_DATE_ACTION':
            return action
        case 'RESET_CMA_DATE_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetCmaDetailReportReducer = (state = { type: 'LOADING_CMA_DETAIL_REPORT_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_CMA_DETAIL_REPORT_ACTION':
            return action
        case 'RESET_CMA_DETAIL_REPORT_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetWoodmacPageFilterReducer = (state = { type: 'LOADING_WOODMAC_PAGE_FILTER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_WOODMAC_PAGE_FILTER_ACTION':
            return { ...state, type: 'LOADING_WOODMAC_PAGE_FILTER_ACTION', loading: true };
        case 'SUCCESS_WOODMAC_PAGE_FILTER_ACTION':
            return { ...action, loading: false };
        case 'ERROR_WOODMAC_PAGE_FILTER_ACTION':
            return { ...state, type: 'ERROR_WOODMAC_PAGE_FILTER_ACTION', loading: false, error: action.error };
        case 'RESET_WOODMAC_PAGE_FILTER_ACTION':
            return {
                ...state,
                type: action.payload,
            };
        default:
            return state
    }
}

const GetWoodmacLineChartReducer = (state = { type: 'LOADING_WOODMAC_LINE_CHART_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_WOODMAC_LINE_CHART_ACTION':
            return { ...state, type: 'LOADING_WOODMAC_LINE_CHART_ACTION', loading: true };
        case 'SUCCESS_WOODMAC_LINE_CHART_ACTION':
            return { ...action, loading: false };
        case 'ERROR_WOODMAC_LINE_CHART_ACTION':
            return { ...state, type: 'ERROR_WOODMAC_LINE_CHART_ACTION', loading: false, error: action.error };
        case 'RESET_WOODMAC_LINE_CHART_ACTION':
            return {
                ...state,
                type: action.payload,
            };
        default:
            return state
    }
}

const GetWoodmacTableReducer = (state = { type: 'LOADING_WOODMAC_TABLE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_WOODMAC_TABLE_ACTION':
            return { ...state, type: 'LOADING_WOODMAC_TABLE_ACTION', loading: true };
        case 'SUCCESS_WOODMAC_TABLE_ACTION':
            return { ...action, loading: false };
        case 'ERROR_WOODMAC_TABLE_ACTION':
            return { ...state, type: 'ERROR_WOODMAC_TABLE_ACTION', loading: false, error: action.error };
        case 'RESET_WOODMAC_TABLE_ACTION':
            return {
                ...state,
                type: action.payload,
            };
        default:
            return state
    }
}

const GetWoodmacDateReducer = (state = { type: 'LOADING_WOODMAC_DATE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_WOODMAC_DATE_ACTION':
            return action
        case 'RESET_WOODMAC_DATE_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const GetWoodmacDetailReportReducer = (state = { type: 'LOADING_WOODMAC_DETAIL_REPORT_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_WOODMAC_DETAIL_REPORT_ACTION':
            return action
        case 'RESET_WOODMAC_DETAIL_REPORT_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}
export {
    GetSBACCIDateReducer,
    GetSBACCIDetailReducer,
    GetCommodityLandingSBACCIReportCountReducer,
    GetCMAPageFilterReducer,
    GetCMALineChartReducer,
    GetCMADateReducer,
    GetCmaDetailReportReducer,
    GetCMATableReducer,
    GetWoodmacPageFilterReducer,
    GetWoodmacLineChartReducer,
    GetWoodmacTableReducer,
    GetWoodmacDateReducer,
    GetWoodmacDetailReportReducer
}